/**
 * @generated SignedSource<<3e770de31c0dbcd6646d2b93105a0556>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArchiveMarketingEmailDialog_marketingEmail$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "ArchiveMarketingEmailDialog_marketingEmail";
};
export type ArchiveMarketingEmailDialog_marketingEmail$key = {
  readonly " $data"?: ArchiveMarketingEmailDialog_marketingEmail$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArchiveMarketingEmailDialog_marketingEmail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchiveMarketingEmailDialog_marketingEmail",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "MarketingEmail",
  "abstractKey": null
};

(node as any).hash = "9ae5e2afa81e155279658662dd17451b";

export default node;
